import { PageTemplate } from '@/components/PageTemplate'
import { NavLink } from '@/components/NavLink'
import { ALL_QUESTIONS } from '@/sections/Faq/questions'

/**
 * /faq — все 11 вопросов (ru-only).
 *
 * На главной после редизайна остаётся шесть вопросов; остальные пять не
 * должны исчезнуть с сайта, поэтому полный список живёт здесь. Ответы
 * развёрнуты, а не спрятаны в аккордеон: FAQPage описывает ровно то, что
 * человек видит на экране, включая вставки «как это было в живом проекте».
 *
 * Тексты не правятся здесь — источник один, src/sections/Faq/questions.ts.
 */

const URL = 'https://dnai.engineering/faq'

const TITLE = 'Вопросы о внедрении ИИ в бизнес: 11 прямых ответов | DNAI'
const DESCRIPTION =
  'Частые вопросы собственников о внедрении ИИ в бизнес: время руководителей, безопасность данных и 152-ФЗ, галлюцинации, санкции, договор, оплата и команда.'

const SCHEMA = [
  {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    url: URL,
    inLanguage: 'ru-RU',
    mainEntity: ALL_QUESTIONS.map((item) => ({
      '@type': 'Question',
      name: item.q,
      acceptedAnswer: {
        '@type': 'Answer',
        // Вставка из живого проекта видна на странице — значит, входит и в разметку
        text: item.live ? `${item.a} ${item.live}` : item.a,
      },
    })),
  },
  {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: 'Главная', item: 'https://dnai.engineering/' },
      { '@type': 'ListItem', position: 2, name: 'Вопросы и ответы', item: URL },
    ],
  },
]

export default function FaqPage() {
  return (
    <PageTemplate title={TITLE} description={DESCRIPTION} canonical={URL} schemaJsonLd={SCHEMA}>
      <article className="section">
        <div className="container-x max-w-prose">
          <nav aria-label="Хлебные крошки" className="text-small text-muted mb-6">
            <NavLink href="/" className="text-muted hover:text-ink no-underline">
              Главная
            </NavLink>
            <span aria-hidden> / </span>
            <span>Вопросы и ответы</span>
          </nav>

          <div className="text-small uppercase tracking-wider text-accent mb-4 font-medium">
            Вопросы и ответы
          </div>
          <h1 className="text-h1 text-ink leading-tight font-serif">
            Вопросы о внедрении ИИ в бизнес — и прямые ответы
          </h1>
          <p className="mt-8 text-body text-muted leading-relaxed">
            Здесь собраны одиннадцать вопросов, которые собственники задают до старта внедрения ИИ
            в бизнес: про время руководителей, безопасность данных и 152-ФЗ, галлюцинации моделей,
            санкционные риски, договор и оплату, сопротивление команды. Отвечаем прямо, без
            смягчений. Там, где есть подтверждение из живого проекта, оно
            приведено отдельной строкой под ответом. Не нашли свой вопрос — задайте его на
            бесплатной диагностике.
          </p>

          <div className="mt-12">
            {ALL_QUESTIONS.map((item) => (
              <section key={item.q} className="border-b border-divider py-8">
                <h2 className="text-h3 text-ink font-medium leading-snug">{item.q}</h2>
                <p className="mt-4 text-body text-muted leading-relaxed">{item.a}</p>
                {item.live && (
                  <p className="mt-4 text-small text-ink border-l-2 border-accent pl-4">
                    {item.live}
                  </p>
                )}
              </section>
            ))}
          </div>

          <div className="mt-12">
            <NavLink href="#final-cta" className="btn-primary no-underline">
              Записаться на диагностику
            </NavLink>
          </div>
        </div>
      </article>
    </PageTemplate>
  )
}
